import * as types from '../../mutation-types'
import * as service from '@/service/httpService'
import {globalService} from '@/service/globalService'
// initial state

const state = {
  pushTargetHistoryDB: [
    // {dbName:'',firstName:'',secondName:''}
  ],
  // 领域数据
  domainData: [],
  // 一级库数据
  historyData: [],
  // 属性数据
  propertyData: []
}

// getters
const getters = {
  pushTargetHistoryDB: state => state.pushTargetHistoryDB,
  domainData: state => state.domainData,
  historyData: state => state.historyData,
  propertyData: state => state.propertyData
}

// actions
const actions = {
  // 加载领域数据
  loadDomainData ({commit}) {
    service.configService.getDomain().then(
      function (response) {
        commit(types.DATA_MANAGE_DOMAIN_DATA, response.data)
      },
      function (response) {
        globalService.showErrNofify(response)
      }
    )
  },
  // 加载一级库数据
  loadHistoryData ({commit}) {
    service.historyColumnService.groupColumns().then(
      function (response) {
        commit(types.DATA_MANAGE_HISTORY_DATA, response.data)
      },
      function (response) {
        globalService.showErrNofify(response)
      }
    )
  },
  // 加载属性数据
  loadPropertyData ({commit}) {
    service.configService.getProperty().then(
      function (response) {
        commit(types.DATA_MANAGE_PROPERTY_DATA, response.data)
      },
      function (response) {
        globalService.showErrNofify(response)
      }
    )
  }
}

// mutations
const mutations = {
  [types.DATA_MANAGE_PUSH_TARGET] (state, pushTarget) {
    state.pushTargetHistoryDB = pushTarget
  },
  [types.DATA_MANAGE_DOMAIN_DATA] (state, domainData) {
    state.domainData = domainData
  },
  [types.DATA_MANAGE_HISTORY_DATA] (state, historyData) {
    state.historyData = historyData
  },
  [types.DATA_MANAGE_PROPERTY_DATA] (state, propertyData) {
    state.propertyData = propertyData
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/data-manage/data-manage.js